export const GROUP_DEFAULTS = {
  csvtreenodebindings: [],
  exclusions: {
    googlegroupbindings: [],
    googleorgbindings: [],
    o365groupbindings: [],
    oktagroupbindings: []
  },
  gmailpush: {
    automatic: false,
    pushtype: 'ptp'
  },
  googlegroupbindings: [],
  googleorgbindings: [],
  groupname: '',
  o365groupbindings: [],
  oktagroupbindings: [],
  params: [],
  senderexclusions: [],
  senders: [],
  tags: [],
  userAttrs: '',
  _id: null,
  _newObject: true
};
